export default __webpack_public_path__ + "static/brand-logo-ember-inns-a97728a4e093c1116f852aa0b38a92fd.png";